export interface AiPersonalityOption {
  id: string
  title: string
  description: string
}

export const AI_PERSONALITY_OPTIONS: AiPersonalityOption[] = [
  { id: 'friendly_tutor', title: 'Friendly Tutor', description: 'Encouraging, patient, and explains mistakes gently.' },
  { id: 'strict_sensei', title: 'Strict Sensei', description: 'Direct corrections and faster pacing to push you.' },
  { id: 'travel_guide', title: 'Travel Guide', description: 'Focuses on practical phrases for trips and navigation.' },
  { id: 'casual_friend', title: 'Casual Friend', description: 'Light, conversational tone for everyday small talk.' },
  { id: 'anime_hero', title: 'Anime Hero', description: 'Disciplined, encouraging, and a bit dramatic to hype you up.' },
  { id: 'playful_bully', title: 'Playful Bully', description: 'Lighthearted roasting keeps you sharp, then shows the right way.' },
]
